import { render } from "./BDAExtraction.vue?vue&type=template&id=0400d0fc&scoped=true"
import script from "./BDAExtraction.vue?vue&type=script&lang=js"
export * from "./BDAExtraction.vue?vue&type=script&lang=js"

import "./BDAExtraction.vue?vue&type=style&index=0&id=0400d0fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0400d0fc"]])

export default __exports__